export const ERROR_USER_EMAIL_EXISTS = 'Auth.form.error.username.taken';
export const ERROR_ROLE_NAME_EXISTS =
  'user-permissions.form.error.role.name.taken';
export const ERROR_ROLE_WITH_USERS =
  'user-permissions.form.error.role.with.users';
export const ERROR_USER_EMAIL_NOT_EXISTS = 'Auth.form.error.user.not-exist';
export const ERROR_USER_PASSWORD_NOT_MATCHING =
  'Auth.form.error.password.matching';
export const ERROR_USER_INVALID_CODE = 'Auth.form.error.code.provide';
